export const MODEL = 'model';
